import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import type { AuthModalView } from '@/context/AuthModalContext'

const TABS: { key: Extract<AuthModalView, 'login' | 'register'>; label: string }[] = [
	{ key: 'login', label: 'Login' },
	{ key: 'register', label: 'Register' },
]

interface AuthModalTabsProps {
	activeView: AuthModalView
	onChange: (view: Extract<AuthModalView, 'login' | 'register'>) => void
}

export function AuthModalTabs({ activeView, onChange }: AuthModalTabsProps) {
	const highlightedView = activeView === 'forgot-password' ? 'login' : activeView

	return (
		<div className='rounded-xl border border-border bg-border p-1'>
			<div className='grid grid-cols-2 gap-0.5'>
				{TABS.map((tab) => {
					const isActive = highlightedView === tab.key
					return (
						<button
							key={tab.key}
							type='button'
							onClick={() => onChange(tab.key)}
							className={cn(
								'group relative flex flex-col items-center justify-center rounded-[10px] px-4 py-3.5 transition-colors',
								'hover:bg-[radial-gradient(circle_3rem_at_50%_150%_in_hsl_shorter_hue,transparent_0%,hsl(var(--border))_90%,hsl(var(--border))_100%),linear-gradient(90deg,hsl(var(--primary)/0.5),hsl(var(--primary)/0.5))]',
								isActive ? 'text-foreground' : 'text-muted-foreground hover:text-foreground',
							)}
						>
							{isActive ? (
								<motion.span
									layoutId='auth-tab-highlight'
									className='absolute inset-0 rounded-[10px] bg-secondary'
									transition={{ type: 'spring', stiffness: 500, damping: 35 }}
									aria-hidden
								/>
							) : null}
							<span className='relative z-10 text-base font-semibold tracking-[-0.24px]'>{tab.label}</span>
							<span
								className={cn(
									'relative top-2.5 z-10 h-0.5 w-9 rounded-full transition-all duration-300 ease-out group-hover:bg-primary',
									isActive ? 'bg-primary shadow-[0_0_4px_1px_hsl(var(--primary)/0.55)]' : 'bg-white/10',
								)}
							/>
						</button>
					)
				})}
			</div>
		</div>
	)
}
